import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isMobile: false,
  isCreateORCode: false,
  showAuth: false,
};

const UISlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setIsMobile: (state, action) => {
      state.isMobile = action.payload;
    },
    setIsCreateORCode: (state, action) => {
      state.isCreateORCode = action.payload;
    },
    setShowAuth: (state, action) => {
      state.showAuth = action.payload;
    } 
  }
});

export const { setIsMobile, setIsCreateORCode, setShowAuth } = UISlice.actions;
export default UISlice.reducer;